import script from "./CompanionPlayer.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanionPlayer.vue?vue&type=script&lang=ts&setup=true"

import "./CompanionPlayer.vue?vue&type=style&index=0&id=50888dd6&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50888dd6"]])

export default __exports__